/**
 * Component: BackStrip
 * BackStrip component used to show strip on a top of the page to go previous page and to show categories menu.
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as settingsActions from "../../../store/portal";

class BackStrip extends React.Component {
  constructor(props) {
    super(props);
    this.onClickburgerMenu = this.onClickburgerMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    // this.onCatchange = this.onCatchange.bind(this);
    this.header_ref = React.createRef();
    this.state = {
      active: false,
      catClick: false,
      categories: [],
      header_position: "static",
    };
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    const header_height = this.header_ref.current
      ? this.header_ref.current.offsetHeight
      : 50;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    // console.log(winScroll)
    if (winScroll < header_height) {
      document.body.style.paddingTop = 0;
    }
    window.addEventListener("scroll", this.handleScroll);
  }
  /**
   * It is a react lifycycle method which is invoked immediately after a component is unmounted
   */
  componentWillUnmount() {
    document.body.className = "";
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const header_height = this.header_ref.current
      ? this.header_ref.current.offsetHeight
      : 50;
    // console.log('header............', header_height)
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    // console.log(winScroll)
    if (winScroll >= header_height) {
      this.setState({
        header_position: "fixed",
      });
      document.body.style.paddingTop = header_height + "px";
    } else {
      this.setState({
        header_position: "static",
      });
      document.body.style.paddingTop = 0;
    }
  }

  componentDidUpdate(prevProps) {
    // console.log(prevProps)
    // console.log(this.props)
    if (this.props.isFilter === "true") {
      if (this.props.data.length > 0 && this.state.categories.length === 0) {
        const { data } = this.props;
        const categories = this.state.categories;
        if (data && data.length > 0) {
          data.forEach((item, index) => {
            categories.push({
              audience_type_id: item.audience_type_id,
              isClicked: false,
              category_background_color: item.category_background_color,
              postcategoryUid: item.postcategoryUid,
              categoryname: item.categoryname,
            });
          });
          this.setState({ categories });
        }
      }
    }
  }

  onClickburgerMenu(e) {
    e.preventDefault();
    const currentState = this.state.active;
    this.setState({ active: !currentState });
    if (this.state.active) {
      document.body.className = "";
    } else {
      document.body.className = "overflow-wrap";
    }
  }

  onCatchange(cat) {
    let categories = this.state.categories;
    // let setlectedCat = ''
    categories.forEach((item, index) => {
      if (item.postcategoryUid === cat.postcategoryUid) {
        item.isClicked = !item.isClicked;
        // setlectedCat = item
      }
    });
    this.setState({
      categories,
    });
    this.props.onCategoryChange(this.state.categories);
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    return (
      <div>
        <nav id="sidebar" className={this.state.active ? "active" : null}>
          <ul className="list-unstyled components bg-secondary">
            <li className="active">
              <i
                className="fa fa-bars"
                id="dismiss"
                onClick={this.onClickburgerMenu}
              ></i>
            </li>
          </ul>
          <div className="nav-wrapper">
            {this.state.categories &&
              this.state.categories.map((item, index) => (
                <div
                  className="d-flex align-items-center text-center"
                  key={item.postcategoryUid}
                >
                  <div
                    className="col-10 text-white"
                    style={{ backgroundColor: item.category_background_color }}
                  >
                    <span>{item.categoryname}</span>
                  </div>
                  <div className="col-1">
                    <a
                      href="javascript:;"
                      onClick={() => this.onCatchange(item)}
                    >
                      <i
                        className={
                          item.isClicked ? "fa fa-eye-slash" : "fa fa-eye"
                        }
                      ></i>
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </nav>
        <div
          className={this.state.active ? "overlay active" : "overlay"}
          onClick={this.onClickburgerMenu}
        ></div>
        <div
          ref={this.header_ref}
          style={{
            backgroundColor: this.props.settings.theme_colours.header_colour.toString(),
            position: this.state.header_position,
            top: "0px",
            width: "100%",
          }}
          className="container-fluid nav1"
        >
          <div className="row justify-content-between">
            <NavLink to={this.props.nav}>
              <i className="fa fa-arrow-left"></i>
            </NavLink>
            {this.props.isFilter === "true" ? (
              <button
                type="button"
                id="sidebarCollapse"
                onClick={this.onClickburgerMenu}
                className="btn"
              >
                <span>
                  <i className="fa fa-bars"></i>
                </span>
              </button>
            ) : (
              ""
            )}
            {this.props.heading ? (
              <div className="d-flex align-items-center m-auto">
                <i className={this.props.heading.icon}></i>
                <span className="title">{this.props.heading.text}</span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}
/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  // console.log('state....', state)
  // console.log('props.', props)

  return {
    user: state.user.user,
    settings: state.user.user
      ? state.settings.byId[state.user.user.schoolUid]
      : "",
  };
}
/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(settingsActions, dispatch)
)(BackStrip);
